import React from "react";

import ContentLoader from "react-content-loader";

const Loader = ({ width = "80%" }) => (
  <ContentLoader width={width}>
    <rect x="0" y="17" rx="4" ry="4" width="70%" height="16" />
    <rect x="0" y="40" rx="3" ry="3" width="60%" height="13" />
    <rect x="0" y="60" rx="3" ry="3" width="50%" height="10" />
  </ContentLoader>
);

const CardSkeleton = ({ isRect = false, ...props }) => {
  return (
    <ContentLoader viewBox="0 0 260 160" height={160} width={260} {...props}>
      {isRect ? (
        <rect x="10" y="10" rx="4" ry="4" width="30" height="30" />
      ) : (
        <circle cx="40" cy="20" r="20" />
      )}
      <rect x="10" y="70" rx="3" ry="3" width="40" height="10" />
      <rect x="60" y="70" rx="3" ry="3" width="70" height="10" />
      <rect x="140" y="70" rx="3" ry="3" width="20" height="10" />
      <rect x="10" y="90" rx="3" ry="3" width="90" height="10" />
      <rect x="110" y="90" rx="3" ry="3" width="70" height="10" />
      <rect x="10" y="110" rx="3" ry="3" width="70" height="10" />
      <rect x="90" y="110" rx="3" ry="3" width="60" height="10" />
    </ContentLoader>
  )
}

export default Loader;

export { CardSkeleton };
